import type { Account } from '@/scripts/cloud/types';

export interface MainSettingsStore {
  editDelayedTime: number;
  setEditDelayedTime: (time: number) => void;
  luckyBoxDeadline: number;
  syncBackupContactChecked: boolean;
  syncBackupWalletChecked: boolean;
  setLuckyBoxDeadline: (deadline: number) => void;
  setSyncAndBackupContacts: (value: boolean) => void;
  setSyncAndBackupWallet: (value: boolean) => void;
  syncBackupStatus: SyncBackupStatus | null;
  syncBackupCloudData: (params?: {
    type?: SyncBackupType;
    info?: {
      deleted_accounts?: string[];
      deleted_wallets?: string[];
      accounts?: Account[];
      updateTime?: number;
      isChangedPassword?: boolean;
    };
  }) => Promise<void>;
}

export type FontSize = 12 | 14 | 16 | 18 | 20 | 22 | 24;

export type FontStore = {
  fontSize: FontSize;
  setFontSize: (size: FontSize) => void;
  normal: FontSize;
  marks: FontSize[];
};

export enum ChatLinesEnum {
  Two = 2,
  Three = 3,
}

export type ChatLinesStore = {
  chatLines: ChatLinesEnum;
  setChatLines: (lines: ChatLinesEnum) => void;
};

export type SettingsStore = MainSettingsStore & FontStore & ChatLinesStore;

export enum SyncBackupStatus {
  UN_AUTHORIZED = 'un_authorized',
  ABNORMAL = 'abnormal',
}

export enum SyncBackupType {
  ALL = 'all',
  WALLET = 'wallet',
  CONTACTS = 'contacts',
}
